import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class AttendanceResultApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'attendance-result'
  }

  /**
   * 高层表格
   */
  public getStatistics(ids) {
    return this.send(ids,"getStatistics", this.Methods.POST)
  }


  public insert(param) {
    return this.send(param,"insert", this.Methods.POST)
  }

  public getUser(param) {
    return this.send(param,"getUser", this.Methods.POST)
  }

  /**
   * 获取餐补次数
   * @param userId
   */
  public getMealCount(userId) {
    return this.send({userId: userId},"getMealCount", this.Methods.GET)
  }



}